/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';

import {
  invoiceCleanSuccess,
  invoiceRequestInit,
  invoiceRequestSuccess,
  invoiceRequestFail,
} from 'state/actions/invoices';

export const initialState = {
  loading: false,
  error: null,
};

const invoicesReducer = createReducer(initialState, {
  [invoiceCleanSuccess]: (state) => {
    state.loading = false;
    state.error = null;
    state.success = false;
  },
  [invoiceRequestInit]: (state) => {
    state.loading = true;
  },
  [invoiceRequestSuccess]: (state) => {
    state.loading = false;
    state.error = null;
    state.success = true;
  },
  [invoiceRequestFail]: (state, action) => {
    const { error } = action.payload;
    state.loading = false;
    state.error = error;
  },
});

export default invoicesReducer;
